









import { Component, Prop, Vue, Provide } from 'vue-property-decorator';
import vmosServices from '@/services/vmosData';
import FlyoutGroup from './components/FlyoutGroup/FlyoutGroup.vue';
import { FlyoutData, FlyoutKeys, FlyoutDataI18n, FlyoutDataItem } from '@/lib/interfaces';

@Component({
  name: 'FlyoutWrapper',
  components: {
    FlyoutGroup,
  },
})
export default class FlyoutWrapper extends Vue {
  @Prop({ required: true, type: String }) private country!: string;
  @Prop({ required: true, type: String }) private language!: string;
  @Provide('i18n') private i18n: FlyoutDataI18n = { values: {} };
  private importedData: FlyoutData = {} as FlyoutData;
  //We use this variable to sort the different menu groups in a specified order
  private groupsSort: string[] = ['allModels','filters', 'subGroups','groups'];
  created(): void {
    this.loadData();
  }

  async loadData(): Promise<void> {
    this.importedData = await vmosServices.getLiveSummary({ market: this.country, language: this.language });
    this.i18n.values = this.importedData['i18n'];
  }

  get navCategories(): FlyoutDataItem[] {
    const importedDataCopy = {...this.importedData};
    importedDataCopy.allModels = [];
    let categories = Object.keys(importedDataCopy)
      .filter((key) => key !== 'i18n')
      .sort((a: any, b: any) => {
        return this.groupsSort.indexOf(a) - this.groupsSort.indexOf(b);
      })
      .reduce((obj: any, key: any) => {
        // We have here a special case, where an Item is coming  inside a group from Backend, 
        // but we need it as it's own group, so we take it out of the group and create a new one
        if(key === 'groups') {
          const allModelsItem = importedDataCopy.groups.filter((item: any) => item.nameI18nKey === 'group.all.name');
          if(allModelsItem.length === 1) {
            importedDataCopy.groups.splice(importedDataCopy.groups.indexOf(allModelsItem[0]), 1);
            obj['allModels'] = allModelsItem;
          }
        }
        obj[key] = importedDataCopy[key as FlyoutKeys];

        return obj;
      }, {});
    return categories;
  }
}
